export default __webpack_public_path__ + "static/media/Esther_Yunkin_AHV_In_Moms_We_Trust.c553ffd3.jpg";